import {
  getFormData,
  resetFormErrors,
  showFormErrors,
} from '../../utils/form';
import * as notification from '../../components/notifications';
import {initTextEditor} from "../../utils/editor";
import {initCustomFieldsTagsInput, setCustomFieldsData} from "../../utils/custom_fields";

let editCompanyProfileForm = null;

const initPage = () => {
  editCompanyProfileForm = $("#edit-company-profile-form");
  if (!editCompanyProfileForm.length) {
    return;
  }

  initTextEditor('quill-container-with-employer-description');

  initCustomFieldsTagsInput()
  editCompanyProfileForm.submit(() => {
    editProfile();

    return false;
  });

};

const getEditCompanyProfileData = () => {
  const data = getFormData(editCompanyProfileForm);

  if (data.custom_fields) {
    data.custom_fields = setCustomFieldsData(data.custom_fields, editCompanyProfileForm.attr('id'));
  }

  return data;
};

const editProfile = async () => {
  const data = getEditCompanyProfileData();

  $('.btn-submit', editCompanyProfileForm).loading();

  try {
    let response;
    response = await axios.patch("/api/employers/current", data);

    resetFormErrors(editCompanyProfileForm);
    notification.success(response.data.message);

    $('.btn-submit', editCompanyProfileForm).loading(false);
  } catch (e) {
    console.log('error', e);

    $('.btn-submit', editCompanyProfileForm).loading(false);

    showFormErrors(editCompanyProfileForm, e.response);
  }
};

$(initPage);
